export default "__VITE_ASSET__d1deecae__"